export const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const QueryStringParameters = {};

  params.forEach((v: any, k: any) => {
    Object.assign(QueryStringParameters, { [k]: v });
  });

  return QueryStringParameters;
};
